import { render, staticRenderFns } from "./MapProv.vue?vue&type=template&id=05ffe8ae&scoped=true"
import script from "./MapProv.vue?vue&type=script&lang=js"
export * from "./MapProv.vue?vue&type=script&lang=js"
import style0 from "./MapProv.vue?vue&type=style&index=0&id=05ffe8ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ffe8ae",
  null
  
)

export default component.exports